import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { wrapModalPromise, WrapModalProps } from '@/utils';
import style from './index.module.css';
import { CommonModal } from '@/components/Modal/CommonModal';

type ArchiveSessionModalProp = {
  otherSideName: string;
  onConfirm: () => Promise<void>;
  refetchCallback?: () => void;
};

const ArchiveSessionModal = ({
  refetchCallback,
  otherSideName,
  onConfirm,
  hide,
}: ArchiveSessionModalProp & WrapModalProps) => {
  const { t } = useTranslation();

  const confirmCallback = useCallback(async () => {
    onConfirm().then(() => {
      hide();
    });
  }, [hide, onConfirm]);
  return (
    <CommonModal
      turnOff={hide}
      onConfirm={confirmCallback}
      headerTitle={t('ArchiveSessionModal.title', { name: otherSideName })}>
      <div className={style.confirmModalBody}>
        {t('ArchiveSessionModal.i209j2')}
        <br />
        {t('ArchiveSessionModal.15o215l')}
      </div>
    </CommonModal>
  );
};

export const openArchiveSessionModal = wrapModalPromise<ArchiveSessionModalProp, void>(
  ArchiveSessionModal,
  {
    wrapInCommonModal: false,
  },
);
